import { getAppVersion } from '@/utils/app'

export async function getFullVersion() {
  return `${await getAppVersion()}/${import.meta.env.VITE_CLIENT_VERSION || 0}`
}
